export default __webpack_public_path__ + "static/media/notification.9be1bc13.svg";